import { render, staticRenderFns } from "./DiagnosticTestResult.vue?vue&type=template&id=404ff934&scoped=true&"
import script from "./DiagnosticTestResult.vue?vue&type=script&lang=js&"
export * from "./DiagnosticTestResult.vue?vue&type=script&lang=js&"
import style0 from "./DiagnosticTestResult.vue?vue&type=style&index=0&id=404ff934&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404ff934",
  null
  
)

export default component.exports